import { render, staticRenderFns } from "./Kasa.vue?vue&type=template&id=0f788d1e&scoped=true"
import script from "./Kasa.vue?vue&type=script&lang=js"
export * from "./Kasa.vue?vue&type=script&lang=js"
import style0 from "./Kasa.vue?vue&type=style&index=0&id=0f788d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f788d1e",
  null
  
)

export default component.exports